module.exports = __webpack_public_path__ + "assets/img/logo-stripe-futurepay.2220ac3e.png";